"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var stremio_router_1 = require("stremio-router");
var useRouteFocused_1 = __importStar(require("stremio/common/useRouteFocused"));
var useOrientation_1 = __importDefault(require("stremio/common/useOrientation"));
var useSheetDrag_1 = __importDefault(require("./useSheetDrag"));
var BottomSheet_less_1 = __importDefault(require("./BottomSheet.less"));
var ANIMATION_DURATION = Number.parseInt(BottomSheet_less_1.default.animationDurationMs, 10) || 250;
var BottomSheet = function (_a) {
    var _b, _c;
    var children = _a.children, className = _a.className, title = _a.title, ariaLabel = _a.ariaLabel, show = _a.show, onCloseRequest = _a.onCloseRequest, onExited = _a.onExited, _d = _a.closeOnContentClick, closeOnContentClick = _d === void 0 ? true : _d, _e = _a.closeOnOrientationChange, closeOnOrientationChange = _e === void 0 ? true : _e, _f = _a.flush, flush = _f === void 0 ? false : _f;
    var t = (0, react_i18next_1.useTranslation)().t;
    var routeFocused = (0, useRouteFocused_1.default)();
    var routeActive = (0, useRouteFocused_1.useRouteActive)();
    var modalsContainer = (0, stremio_router_1.useModalsContainer)();
    var modalRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    var onCloseRequestRef = (0, react_1.useRef)(onCloseRequest);
    var onExitedRef = (0, react_1.useRef)(onExited);
    var phaseRef = (0, react_1.useRef)('idle');
    var orientation = (0, useOrientation_1.default)();
    var previousOrientationRef = (0, react_1.useRef)(orientation);
    var _g = (0, react_1.useState)('idle'), phase = _g[0], setPhase = _g[1];
    (0, react_1.useLayoutEffect)(function () {
        onCloseRequestRef.current = onCloseRequest;
        onExitedRef.current = onExited;
    }, [onCloseRequest, onExited]);
    var setPhaseState = (0, react_1.useCallback)(function (next) {
        phaseRef.current = next;
        setPhase(next);
    }, []);
    var labelledBy = typeof title === 'string' && title.length > 0 ? title : ariaLabel;
    var open = phase === 'entered';
    var mounted = phase !== 'idle';
    var requestClose = (0, react_1.useCallback)(function () {
        if (phaseRef.current === 'idle' || phaseRef.current === 'exiting') {
            return;
        }
        onCloseRequestRef.current();
    }, []);
    (0, react_1.useEffect)(function () {
        if (!routeActive)
            requestClose();
    }, [routeActive, requestClose]);
    var isExiting = (0, react_1.useCallback)(function () { return phaseRef.current === 'exiting'; }, []);
    var _h = (0, useSheetDrag_1.default)({ containerRef: containerRef, enabled: mounted, isExiting: isExiting, onDismiss: requestClose }), offset = _h.offset, dragging = _h.dragging, resetDrag = _h.reset;
    (0, react_1.useEffect)(function () {
        if (show) {
            resetDrag();
            setPhaseState('entering');
            return undefined;
        }
        if (phaseRef.current === 'idle') {
            return undefined;
        }
        resetDrag();
        setPhaseState('exiting');
        return undefined;
    }, [show, setPhaseState, resetDrag]);
    (0, react_1.useEffect)(function () {
        if (phase !== 'entering') {
            return undefined;
        }
        var node = containerRef.current;
        if (node !== null) {
            node.getBoundingClientRect();
        }
        var frame = requestAnimationFrame(function () {
            if (phaseRef.current === 'entering') {
                setPhaseState('entered');
            }
        });
        return function () { return window.cancelAnimationFrame(frame); };
    }, [phase, setPhaseState]);
    (0, react_1.useEffect)(function () {
        if (phase !== 'exiting') {
            return undefined;
        }
        var timeout = window.setTimeout(function () {
            var _a;
            setPhaseState('idle');
            resetDrag();
            (_a = onExitedRef.current) === null || _a === void 0 ? void 0 : _a.call(onExitedRef);
        }, ANIMATION_DURATION);
        return function () { return window.clearTimeout(timeout); };
    }, [phase, setPhaseState, resetDrag]);
    (0, react_1.useEffect)(function () {
        if (!mounted || !routeFocused || !(modalsContainer instanceof HTMLElement)) {
            return undefined;
        }
        var onKeyDown = function (event) {
            if (event.code !== 'Escape') {
                return;
            }
            if (modalsContainer.childNodes[modalsContainer.childElementCount - 2] !== modalRef.current) {
                return;
            }
            requestClose();
        };
        window.addEventListener('keydown', onKeyDown);
        return function () { return window.removeEventListener('keydown', onKeyDown); };
    }, [mounted, routeFocused, modalsContainer, requestClose]);
    (0, react_1.useEffect)(function () {
        if (!closeOnOrientationChange) {
            previousOrientationRef.current = orientation;
            return undefined;
        }
        if (previousOrientationRef.current !== orientation && phaseRef.current !== 'idle') {
            requestClose();
        }
        previousOrientationRef.current = orientation;
        return undefined;
    }, [orientation, closeOnOrientationChange, requestClose]);
    if (phase === 'idle') {
        return null;
    }
    return (react_1.default.createElement(stremio_router_1.Modal, { ref: modalRef, className: (0, classnames_1.default)(BottomSheet_less_1.default['bottom-sheet'], className, (_b = {}, _b[BottomSheet_less_1.default['open']] = open, _b)), autoFocus: true },
        react_1.default.createElement("button", { className: BottomSheet_less_1.default['backdrop'], "aria-label": t('BUTTON_CLOSE'), onClick: requestClose }),
        react_1.default.createElement("div", { ref: containerRef, className: (0, classnames_1.default)(BottomSheet_less_1.default['container'], (_c = {},
                _c[BottomSheet_less_1.default['dragging']] = dragging,
                _c[BottomSheet_less_1.default['flush']] = flush,
                _c)), style: { transform: open ? "translateY(".concat(offset, "px)") : 'translateY(100%)' }, role: 'dialog', "aria-modal": 'true', "aria-label": labelledBy },
            react_1.default.createElement("div", { className: BottomSheet_less_1.default['handle'] }),
            typeof title === 'string' && title.length > 0 ?
                react_1.default.createElement("div", { className: BottomSheet_less_1.default['heading'] },
                    react_1.default.createElement("div", { className: BottomSheet_less_1.default['title'] }, title))
                :
                    null,
            react_1.default.createElement("div", { className: BottomSheet_less_1.default['content'], onClick: closeOnContentClick ? requestClose : undefined }, children))));
};
exports.default = BottomSheet;
